

export const version = "V 14.0.13";
export const versionDate = "September 11, 2026 2:30 PM EDT";
export const versionNotes = "QuickList defaults and export limit";

export const getScoutReports = async (playerID, user) => {
    const API_ENDPOINT = "https://www.fbxchange.com/ReactPHP/scoutreports.php"; // unchanged
    const res = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            scriptName: "getReports",
            ID: playerID,
            scout: user.scout,
            team: user.team || "",
        }),
    });
    const resp = await res.json();
    return resp;
};

export const getOneScoutReport = (reportID, user) => {
    return `scoutReport_${reportID}`;
}
